var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
var StyledSvg = styled.svg(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin: auto;\n    color: #007db6;\n\n    ", "\n"], ["\n    margin: auto;\n    color: #007db6;\n\n    ",
    "\n"])), function (_a) {
    var isDisabled = _a.isDisabled;
    return isDisabled && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            filter: grayscale(100%);\n            opacity: 0.5;\n        "], ["\n            filter: grayscale(100%);\n            opacity: 0.5;\n        "])));
});
export var ClearIcon = function (_a) {
    var _b = _a.isDisabled, isDisabled = _b === void 0 ? false : _b, rest = __rest(_a, ["isDisabled"]);
    return (React.createElement(StyledSvg, __assign({}, rest, { isDisabled: isDisabled, viewBox: "0 0 12 12", width: "12px", height: "12px" }),
        React.createElement("polygon", { fill: "currentColor", points: "7.42 6 12 1.42 10.58 0 6 4.58 1.42 0 0 1.42 4.58 6 0 10.58 1.42 12 6 7.42 10.58 12 12 10.58 7.42 6" })));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=ClearIcon.js.map